export default __webpack_public_path__ + "static/media/gallery_03.1660ae34.jpg";